// src/Components/Keypad.jsx
import React from 'react';
import './Keypad.css';

const KEYPAD_LAYOUT = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
  ['',  '0',  ''] // empty slots around zero
];

const KEYPAD_MAP = {
  '0': '',
  '1': '',
  '2': 'ABC',
  '3': 'DEF',
  '4': 'GHI',
  '5': 'JKL',
  '6': 'MNO',
  '7': 'PQRS',
  '8': 'TUV',
  '9': 'WXYZ'
};

function Keypad({ dailyNumber = '', usedDigits = [] }) {
  // Parse dailyNumber into an object that tracks how many of each digit are available
  const digitCounts = {};
  dailyNumber.replace(/-/g, '').split('').forEach((digit) => {
    digitCounts[digit] = (digitCounts[digit] || 0) + 1;
  });

  // Count how many times each digit has been used
  const usedCounts = {};
  usedDigits.forEach((digit) => {
    usedCounts[digit] = (usedCounts[digit] || 0) + 1;
  });

  return (
    <div className="keypad-container">
      {KEYPAD_LAYOUT.map((row, rowIndex) =>
        row.map((digit, colIndex) => {
          if (!digit) {
            return <div key={`r${rowIndex}c${colIndex}`} className="keypad-placeholder" />;
          }

          const totalAvailable = digitCounts[digit] || 0; // Total appearances in dailyNumber
          const totalUsed = usedCounts[digit] || 0;       // Times user has used this digit
          const remaining = totalAvailable - totalUsed;  // Remaining instances of this digit

          // Decide button color
          let colorClass;
          if (totalAvailable === 0) {
            colorClass = 'grey';  // Digit is not in dailyNumber
          } else if (remaining > 0) {
            colorClass = 'green'; // Digit is available
          } else {
            colorClass = 'red';   // No more instances left
          }

          return (
            <div key={`r${rowIndex}c${colIndex}`} className={`keypad-button ${colorClass}`}>
              <span className="digit">{digit}</span>
              <span className="letters">{KEYPAD_MAP[digit] || ''}</span>
            </div>
          );
        })
      )}
    </div>
  );
}

export default Keypad;